var _ = { escape: require('lodash.escape') };
module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape;
with (obj) {
__p += '<div class="booking-calendar__no-opening-times"> ' +
__e( jqXHR.responseJSON.appointment.server.message ) +
' </div>';

}
return __p
};

/*
original source:

<div class="booking-calendar__no-opening-times">
    <%- jqXHR.responseJSON.appointment.server.message %>
</div>

*/
